<div class="session-photos control">
  <lv-session-attendance-status [sessions]="sessions"></lv-session-attendance-status>

  @if (hasFlaggedPhotos && selectedPhoto) {
    <div class="carousel-selected">
      <img [src]="selectedPhoto.photo.url" lvImgBuffer />
      <button
        selected-previous
        class="button is-primary is-medium"
        (click)="previousPhoto()"
        [disabled]="isFirstPhoto()"
      >
        <span class="icon is-medium">
          <i lvIcon="caret-left"></i>
        </span>
      </button>
      <button selected-next class="button is-primary is-medium" (click)="nextPhoto()" [disabled]="isLastPhoto()">
        <span class="icon is-medium">
          <i lvIcon="caret-right"></i>
        </span>
      </button>
      <div selected-index translate [translateParams]="{ actual: photoNumber, expected: photoCount }">
        session-review-attendance.component.usage
      </div>
      <div selected-timestamp>
        {{ selectedPhoto.createdAt | date: 'yyyy-MM-dd' }} {{ selectedPhoto.createdAt | date: 'mediumTime' }}
      </div>
      <div selected-anomaly class="control" [attr.data-tip]="commentForCurrentPhoto?.comment" data-tip-length="large">
        @if (selectedAnomaly) {
          <span>{{ selectedAnomaly.kind }} (ID #{{ selectedAnomaly.id | idFromGid }})</span>
        }
      </div>
    </div>
  }

  @if (hasFlaggedPhotos) {
    <div class="anomaly-timeline">
      <button class="button is-secondary is-small" (click)="previousAnomaly()" [disabled]="isFirstAnomaly()">
        <span class="icon is-small">
          <i lvIcon="caret-left"></i>
        </span>
      </button>

      <lv-attendance-timeline [sessions]="sessions"></lv-attendance-timeline>

      <button selected-next class="button is-secondary is-small" (click)="nextAnomaly()" [disabled]="isLastAnomaly()">
        <span class="icon is-small">
          <i lvIcon="caret-right"></i>
        </span>
      </button>
    </div>
  } @else {
    <div class="no-photos">
      <span class="icon is-medium">
        <i lvIcon="exclamation-triangle"></i>
      </span>
      <strong translate>session-review-attendance.component.no-flagged-photos</strong>
    </div>
  }
</div>
